/* eslint-disable comma-dangle */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProjectTypeSelector from './ProjectTypeSelector';
import ClearButton from '../ClearButton';
import { clearSearchFilters as clear } from '../../../../actions';

function ProjectTypeList() {
  const { searchFilterProjectTypes } = useSelector((state) => state.env);

  const projectTypes = searchFilterProjectTypes || [];
  const dispatch = useDispatch();

  const resetFilter = () => {
    dispatch(clear(['parent_project_type_ids_contains_element']));
  };

  return (
    <div className="project-type-container">
      <div className="project-type-selector-container">
        {projectTypes.map(
          (projectType) => (
            <ProjectTypeSelector
              key={projectType.id}
              projectType={projectType}
            />
          )
        )}
      </div>
      <ClearButton onClick={resetFilter} />
    </div>
  );
}

export default ProjectTypeList;
